import { useHistory } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export const ActionCard = () => {
  const history = useHistory();
  const { showNewMessage } = useIntercom();

  return (
    <Card className="w-40">
      <CardContent className="flex flex-col space-y-2">
        <Button
          className=""
          onClick={() =>
            showNewMessage(`I'd like to talk to someone about Easements Data"`)
          }
        >
          Talk to an Expert
        </Button>
        <Button
          variant="outline"
          className=""
          onClick={() => {
            history.push(Routes.hub);
          }}
        >
          Exit demo
        </Button>
      </CardContent>
    </Card>
  );
};
